import React from "react"
import quotesImg from "../assets/img/quotes.svg"
// import Image from "gatsby-image"
// import { Link } from "gatsby"
import { graphql, Link, useStaticQuery } from "gatsby"
// import SocialLinks from "../constants/socialLinks"
// ...GatsbyImageSharpFluid
// import {
//   FaLinkedinIn,
//   FaFacebookF,
//   FaTwitter,
//   // FaInstagram,
//   FaMapMarkerAlt,
//   FaEnvelope,
//   // FaPhone,
// } from "react-icons/fa"

function randomQuote(list) {
  let rand = 0 - 0.5 + Math.random() * list.length;
  return list[Math.round(rand)];
}

const Footer = () => {

  const data = useStaticQuery(graphql`
  {
    settings: strapiSettings {
      address {
        address1
        address2
      }
      email
      facebook
      linkedIn
      twitter
      companyName
    }
    quotes: allStrapiQuotes {
      nodes {
        text
        author
      }
    }
    blogs: allStrapiBlogs(sort: {fields: date, order: DESC}, filter: {hidden: {ne: true}}, limit: 3) {
      nodes {
        date(formatString: "MMMM Do, YYYY")
        category
        id
        slug
        title
      }
    }
    products: allStrapiProducts{
      nodes {
        id
        new
        active
        slug
        title
      }
    }
  }
`);
const nowYear = new Date().getFullYear();
const settings = data.settings;
const quotes = data.quotes.nodes;
const quote = randomQuote(quotes);
const blogs = data.blogs.nodes;
const products = data.products.nodes;

  return (
    <section className="gs-footer">
      <div className="gs-sect__in gs-container">
        <div className="gs-footer-columns fww">

          <div className="gs-footer-column fl1 mb2 mr1">
            <h3 className="">CONTACTS</h3>
            <p className="mb05">
              <a
                href="https://goo.gl/maps/pfBJ9aW2iFvz52tm8"
                target="blanc"
                className="gs-footer-link gs-footer-link--street gs-color-yellow"
              >
                <span>
                {settings.address.address1}, <br />
                {settings.address.address2}
                </span>
              </a>
            </p>
            <p className="mb1">
              <a
                href={"mailto:"+settings.email}
                target="blanc"
                className="gs-footer-link gs-color-yellow"
              >
                {settings.email}
              </a>
            </p>
          </div>
          <div className="gs-footer-column fl1 mb2 mr1">
            <h3 className="">FOLLOW US</h3>
            <p className="df fdc mb1">
              <a href={settings.linkedIn} target="_blank" rel="noreferrer" className="gs-footer-link">
                <span className="label">LinkedIn</span>
              </a>
              <a href={settings.facebook} target="_blank" rel="noreferrer" className="gs-footer-link">
                <span className="label">Facebook</span>
              </a>
              {/* <a className="gs-footer-link">
                <FaInstagram className="gs-footer-link__icon gs-footer-link__icon--social" />
                <span className="label">Instagram</span>
              </a> */}
              <a href={settings.twitter} target="_blank" rel="noreferrer" className="gs-footer-link">
                <span className="label">Twitter</span>
              </a>
            </p>
          </div>

          <div className="gs-footer-column fl1 mb2">
            <h3 className="">QUOTE OF THE DAY</h3>
            <div className="gs-footer-quote mb1">
              
              <div className="gs-footer-quote__sign"><img src={quotesImg} alt="Quotes"/></div>
              <div className="gs-footer-quote__text mb1">
                {quote.text}
              </div>
              <div className="gs-footer-quote__author fwb">– {quote.author}</div>
            </div>
          </div>
          
          </div>
          <div className="gs-footer-columns fww">
            <div className="gs-footer-column fl1 mb2 mr1">
              <h3 className="">LINKS</h3>
              <div className="mb1">
                <Link key="Home" to="/" className="gs-footer-link">Home</Link>
                {
                  products.filter(product=>product.active).map(product => {
                    // console.log(product.id);
                    return <Link to={"/"+product.slug} key={product.id} className="gs-footer-link">{product.title}</Link>
                  })
                }
                <Link key="News" to="/news" className="gs-footer-link">News</Link>
                <Link key="videos" to="/videos" className="gs-footer-link">Videos</Link>
                <Link key="Solutions" to="/solutions" className="gs-footer-link">Solutions</Link>
                <Link key="Company" to="/company" className="gs-footer-link">Company</Link>
                <Link key="Contact" to="/contact" className="gs-footer-link">Contact</Link>
              </div>
            </div>
            <div className="gs-footer-column fl2 mb2">
              <h3 className="">LATEST NEWS</h3>
              <div className="mb1">
                {
                  blogs.map(blog => {
                    // console.log(blog.id);
                    return <Link key={blog.id} to={`/blogs/${blog.slug}`} className="gs-footer-link">
                    <div>
                      <span className="fw300 fz08">{blog.date}</span>
                      <h5 className="mb0">{blog.title}</h5>
                    </div>
                  </Link>
                  })
                }
              </div>
            </div>
        </div>
        <div className="gs-footer-copyright">
          © Grundium Ltd {nowYear}. All rights reserved. &nbsp;
          <a
            href="/privacy"
            target="blanc"
            className="gs-color-yellow"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </section>
  )
}

export default Footer
